<template>
   <HeaderTrade />

      <!-- Container Start { -->
      <div id="container" class="sts-trade-container">
        <!-- Contents Start { -->
        <div id="contents">

          <TradeTopNav 
           :pid="route.params.id"
          />
          <div class="chart-info-inner">
            <TopItemInfo v-if="selectItem"
              :selectItem="selectItem"
              :pid="route.params.id"
            /> 
          </div>
          <!-- content start -->
          <div class="contents-area">     

              <div class="trade-chart-area">
                <div class="chart-box">
                      <TVChartContainer  v-if="t_symbol" :symbol="t_symbol" :symbolType="getSymbolType(currentTradeType)" :interval="getChartInterval(currentTradeType)"/> 
                </div>
              </div>

          </div>
          <!-- // content end -->

          <TradeBottomNav 
             :id="route.params.id"
          />

        </div>
        <!-- } Contents End -->
      </div>
      <!-- } Container End -->


</template>

<script>
import { useScoket } from '@/socket';
import { useStore } from 'vuex';
import HeaderTrade from '@/components/HeaderTrade.vue';
import TradeTopNav from "@/components/TradeTopNav.vue"
import TradeBottomNav from "@/components/TradeBottomNav.vue"
import { onMounted, ref, computed, onUnmounted, getCurrentInstance} from 'vue';
import {useRoute }from 'vue-router'
import {useGetItemList} from '@/composables/vtradeFn';
import TopItemInfo from '@/components/trade/TopItemInfo.vue';
import TVChartContainer from '@/components/trade/ChartContainer.vue';
import {generateSymbol} from '@/js/helpers.js';
import Constant from '@/constant.js';

export default {
    components:{   
        HeaderTrade,
        TradeTopNav,
        TradeBottomNav,     
        TopItemInfo,
        TVChartContainer
    },
    setup(){

      const t_symbol = ref(null);

      const store = useStore();
      store.commit('trade/CHANGE_CURRENT_PAGE_BOTTOM', 'tradeChart'); 
      store.commit('trade/CHANGE_CURRENT_PAGE_ID', 'navi_0'); 
      const currentAssetList = computed(()=> store.state.hts.assetlist);
      const selectItem = ref(null);
      const route = useRoute();      
      
      const {socket} = useScoket(); 
  

      const currentTradeType = computed(() => store.state.hts.currentTradeType);
      const  {getItemByCode} = useGetItemList()

      const internalInstance = getCurrentInstance(); 
      const emitter = internalInstance.appContext.config.globalProperties.emitter;  

      //const applySpaceList = computed(()=> store.state.hts.applySpaceList);
      // const getIsApplySpace = (spaceId) =>{
      //     var  found =    applySpaceList.value.find(element => element.SPACE_ID == spaceId);          
      //     if(found)
      //     {
      //       return true;
      //     }
      //     else
      //     {
      //       return false;
      //     }
      // }
      if(route.params.id == '0')
      {
        store.commit('trade/CHANGE_CURRENT_LEAGUETYPE', 'normal');
      }
      else
      {
        store.commit('trade/CHANGE_CURRENT_LEAGUETYPE', 'event');
      }
 
      onMounted(async()=>{

        //  var isApply = getIsApplySpace(store.state.hts.currentSpaceId);
        //   if(isApply)
        //   {
        //      // store.dispatch('hts/getOrderList');
        //      // store.dispatch('hts/getAssetList')
        //   }
        //   else
        //   {              
        //     store.commit('hts/CHANGE_ASSETLIST',[]);
        //     store.commit('hts/CHANGE_TOTAL_POL',{}); 
        //     store.commit('hts/CHANGE_ORDERLIST', []);
        //   }    


        selectItem.value = await getItemByCode(currentTradeType.value, route.params.code);

        var _isNight = false;
        if(selectItem.value.TYPE == 'F')
        {         
          if(selectItem.value.isNight  && String(selectItem.value.isNight) == 'true') 
          { 
              selectItem.value.CODE = selectItem.value.CODE.split('_')[0];                        
              _isNight = true;           
          }
        }
        store.commit('hts/CHANGE_CURRENT_ITEM', selectItem.value);

        if(currentTradeType.value == 'C'){
           t_symbol.value = `Flex:KRW/${selectItem.value.CODE.split('-')[1]}`
        } 
        else if(currentTradeType.value == 'S'){
           t_symbol.value = `Flex:${selectItem.value.CODE}/${'KR'}`
        } else if(currentTradeType.value == 'F'){
          if(selectItem.value.isNight)
          {
            t_symbol.value  = `Flex:${selectItem.value.CODE}_N/${'KR'}`
          }
          else
          {
            t_symbol.value  = `Flex:${selectItem.value.CODE}/${'KR'}`
          }
        } else if(currentTradeType.value == 'G'){  

            var symbol = generateSymbol('Flex',  selectItem.value.CODE.substring(0,selectItem.value.CODE.length-4), selectItem.value.CODE.substring(selectItem.value.CODE.length-4));
            t_symbol.value = symbol.full;
        }
          

       setTimeout(()=>{       
          socket.emit("requestInit", {
                itemType: selectItem.value.TYPE,
                code: selectItem.value.CODE,
                 isNight:_isNight        
            }, function() {  
             // console.log("requestInit:", selectItem.value.CODE)    
                setTimeout(()=>{
                  socket.emit("requestTrade", {
                    itemType:selectItem.value.TYPE,
                    code:selectItem.value.CODE,
                    isNight:_isNight 
                  }, function() { 
                    console.log("requestCode:", selectItem.value.CODE)    
                  })        

                },500)
            })
       },1000)


        setTimeout (()=>{
          if(selectItem.value.TYPE == 'G')
          {
             drawPosition_cf();
          }
          else
          {
             drawPosition();
          }               
        },4000)

      })


      

      onUnmounted(()=>{
          socket.emit("leaveTrade", {
              itemType:  selectItem.value.TYPE,
              code: selectItem.value.CODE,
              isNight:selectItem.value.isNight?selectItem.value.isNight:false
          }, function(e) { 
                console.log("leaveCode:",  e)    
          })  
      })

      const drawPosition_cf = () =>{
         
          if(currentAssetList.value.length > 0) 
          {
            var isAsset_long = false;
            var isAsset_short = false;
            
            currentAssetList.value.forEach(element => {
              if(element.CODE == selectItem.value.CODE)
              {       
                 
                if(element.TRADETYPE == '3')
                {                  
                  emitter.emit('EVENT_CREATE_POSITION_LINE_LONG',{count:Constant.UTIL.numberWithCommas(Constant.UTIL.toFixedNum(element.COUNT, 4)), price:element.PRICE, tradeType:'롱 포지션'});
                  isAsset_long = true;

                }
                else if(element.TRADETYPE == '4')
                {
                  emitter.emit('EVENT_CREATE_POSITION_LINE_SHORT',{count:Constant.UTIL.numberWithCommas(Constant.UTIL.toFixedNum(element.COUNT, 4)), price:element.PRICE, tradeType:'숏 포지션'});
                  isAsset_short = true;
                }
              }
            });

            if(!isAsset_long)
            {                  
              emitter.emit('EVENT_REMOVE_POSITION_LINE_LONG');
            }

            if(!isAsset_short)
            {                  
              emitter.emit('EVENT_REMOVE_POSITION_LINE_SHORT');
            }

          }
          else
          {
            emitter.emit('EVENT_REMOVE_POSITION_LINE_LONG');
            emitter.emit('EVENT_REMOVE_POSITION_LINE_SHORT');
          }
      }
      
     const drawPosition = () =>{
          if(currentAssetList.value.length > 0) 
          {

            var isAsset = false;
            currentAssetList.value.forEach(element => {
              if(element.CODE == selectItem.value.CODE)
              {
                // console.log("element.CODE", element.CODE,  selectItem.value.CODE)
                emitter.emit('EVENT_CREATE_POSITION_LINE',{count:Constant.UTIL.numberWithCommas(Constant.UTIL.toFixedNum(element.COUNT, 2)), price:element.PRICE, tradeType:getTradeType(element.TRADETYPE)});
                isAsset = true
              }
            });


            if(!isAsset)
            {                  
              emitter.emit('EVENT_REMOVE_POSITION_LINE');
            }
          }
          else
          {
              emitter.emit('EVENT_REMOVE_POSITION_LINE');
          }
     }


    const getTradeType = (type) =>{
        switch(type)
        {
            case '1':
                return "매수"                        
            case '2':
                return "매도"                       
            case '3':
                return "매수"                        
            case '4':
                return "매도"
        }
    }


      const getSymbolType = (_type) =>{
        var  result = null;
        if(_type == 'C')
        {
          result = 'crypto'
        }
        else if(_type == 'S')
        {
          result = 'stock'
        }
        else if(_type == 'F')
        {
          result = 'futures'
        }
        else if(_type == 'G')
        {
          result = 'coinFutures'
        }

        return result
      }

      const getChartInterval = (_type) =>{
        var  result = null;
        if(_type == 'C')
        {
          result = store.state.hts.chartIntrval_c
        }
        else if(_type == 'S')
        {
          result = store.state.hts.chartIntrval_s
        }
        else if(_type == 'F')
        {
          result = store.state.hts.chartIntrval_f
        }
        else if(_type == 'G')
        {
          result = store.state.hts.chartIntrval_g
        }
        return result
      }

      return{
        selectItem,
        currentTradeType,
        getSymbolType,
        t_symbol,
        getChartInterval,
        route
        
      }
    }
}
</script>

<style>

</style>